module.exports = __webpack_public_path__ + "static/img/results-banner_new.3f8b06e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/results-banner_new.jpg
// module id = 33wH
// module chunks = 1